import { DatabaseService, Config, ConfigData, ConfigRepository } from "@/core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getConfigRepository(
  databaseService: DatabaseService,
): ConfigRepository {
  return getGenericRepository<Config, ConfigData>(
    () => DatabaseCollection.CONFIGS,
    databaseService,
  );
}

